module.exports = __webpack_public_path__ + "static/intercom-integration5-b5153ea222df405c2367aaf5901bbd4b.png";